import { useToast } from '@chakra-ui/core';

import hideAnyExistingToast from '../utils/hideToast';

export default function useToastMod() {
  // hide existing toasts, if any
  hideAnyExistingToast();
  return useToast();
}
